export const BULK_DELETE_SBAT_GROUP_MODAL_STAGES = {
  notOpen: 'notOpen',
  info: 'info',
  confirm: 'confirm',
};
